export default function GradientLine({ className }) {
  return (
    <div
      className={`w-full h-[1px] bg-gradient-to-r from-transparent via-lz-paper-border to-transparent dark:from-transparent dark:via-lz-charcoal-border dark:to-transparent ${className}`}
    />
  );
}
